module.exports = __webpack_public_path__ + "stylesheets/section-feedback_01f8aa6ade5c92f9fb65e839c3512821.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-feedback.less
// module id = QAC1
// module chunks = 118